import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { lastMonthRange } from '../pages/accounting/ui/dates';

type AccountingPeriodState = {
  dateFrom: string;
  dateTo: string;
  setRange: (from: string, to: string) => void;
  setDateFrom: (v: string) => void;
  setDateTo: (v: string) => void;
  asOf: () => string;
};

const defaults = lastMonthRange();

export const useAccountingPeriodStore = create<AccountingPeriodState>()(
  persist(
    (set, get) => ({
      dateFrom: defaults.dateFrom,
      dateTo: defaults.dateTo,
      setRange: (dateFrom, dateTo) => set({ dateFrom, dateTo }),
      setDateFrom: (dateFrom) => set({ dateFrom }),
      setDateTo: (dateTo) => set({ dateTo }),
      asOf: () => get().dateTo,
    }),
    // v2: default = mes anterior (antes persistía rangos viejos/amplios).
    { name: 'creditnow-accounting-period-v2' },
  ),
);
